module.exports = __webpack_public_path__ + "img/liang.15489516.png";